import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        updatingTourPackage: false,
        loadingTourPackage: false,
        id: null,
        images: [],
        name: "",
        keyContents: Math.random(),
        contents: "",
        travelDate: "",
        duration: "",
        city: "",
        country: "",
        price: 0,
        status: 0,
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadTourPackage = instance => {
    instance.setState({
        ...instance.state,
        loadingTourPackage: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/tour-package",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then(response => handleLoadTourPackageResponse(instance, response))
        .catch(error => alert(error))
}

const handleLoadTourPackageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            const tourPackage = response.data.data.tourPackage || response.data.data.package
            instance.setState({
                ...instance.state,
                loadingTourPackage: false,
                name: tourPackage.name,
                id: tourPackage.id,
                images: tourPackage.images || [],
                contents: tourPackage.contents,
                keyContents: Math.random(),
                travelDate: tourPackage.travelDate,
                duration: tourPackage.duration,
                city: tourPackage.city,
                country: tourPackage.country,
                price: tourPackage.price,
                status: tourPackage.status,
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                loadingTourPackage: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.name, (error) => errors.name = error, { min: { value: 2, error: "Too short" }, max: { value: 150, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.contents, (error) => errors.contents = error, { min: { value: 5, error: "Too short" }, max: { value: 100000, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.travelDate, (error) => errors.travelDate = error, { min: { value: 1, error: "Too short" }, max: { value: 50, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.duration, (error) => errors.duration = error, { min: { value: 1, error: "Too short" }, max: { value: 50, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.city, (error) => errors.city = error, { min: { value: 1, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.country, (error) => errors.country = error, { min: { value: 1, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.price, (error) => errors.price = error, { min: { value: 0, error: "Too low" }, max: { value: 100000000, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.status, (error) => errors.status = error, { min: { value: 0, error: "Too low" }, max: { value: 2, error: "Too high" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const updateTourPackage = (instance) => {
    instance.setState({
        ...instance.state,
        updatingTourPackage: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/tour-package/update",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id,
            name: instance.state.name,
            contents: instance.state.contents,
            travelDate: instance.state.travelDate,
            duration: instance.state.duration,
            city: instance.state.city,
            country: instance.state.country,
            price: instance.state.price,
            status: instance.state.status
        }
    }).then(response => handleUpdateTourPackageResponse(instance, response.data))
        .catch(error => alert(error))
}

const handleUpdateTourPackageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updatingTourPackage: false,
                flag: {
                    type: "success",
                    text: "Tour Package Updated"
                }
            })
            
            break
        default:
            instance.setState({
                ...instance.state,
                updatingTourPackage: false,
                flag: {
                    type: "error",
                    text: response.message
                }
            })
    }
}

const EditTourPackageWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        loadTourPackage: () => loadTourPackage(instance),
        updateTourPackage: () => updateTourPackage(instance)
    }
}

export default EditTourPackageWorker
